<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="container-fluid">
  <dl class="row">
    <div class="container">
      <div class="dialog-title">New Environment</div>
      <cyborg-error *ngIf="error" [error]="error"></cyborg-error>
      <form
        class="k-form"
        [formGroup]="formGroup"
        autocomplete="off"
        (ngSubmit)="onSubmit()"
      >
        <kendo-formfield>
          <label for="name">Environment Name*</label>
          <input id="name" formControlName="name" maxlength="50" kendoTextBox />
          <kendo-formerror>Error: Name is required</kendo-formerror>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label
            [for]="description"
            text="Description"
            class="customizing-label"
          ></kendo-label>
          <kendo-textarea
            #description
            name="description"
            formControlName="description"
            resizable="vertical"
            [maxlength]="200"
          >
          </kendo-textarea>
        </kendo-formfield>

        <button
          themeColor="primary"
          class="dialog-button"
          size="large"
          type="submit"
          [disabled]="!formGroup.valid"
          kendoButton
        >
          Save
        </button>
      </form>
    </div>
  </dl>
</div>
